import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { StudentCompactViewComponent } from '../student-compact-view/student-compact-view.component';
import { CourseService } from '../../services/course.service';

@Component({
  standalone: true,
  selector: 'app-top-performance',
  imports: [CommonModule, StudentCompactViewComponent, TranslatePipe],
  templateUrl: './top-performance.component.html',
  styleUrl: './top-performance.component.scss',
})
export class TopPerformanceComponent {
  #courseService = inject(CourseService);

  students = this.#courseService.topPerformanceStudents;
  isLoading = this.#courseService.topPerformanceLoading;
  currentPage = this.#courseService.topPerformancePage;
  totalPages = this.#courseService.topPerformanceTotalPages;

  goToPage(page: number): void {
    this.#courseService.setTopPerformancePage(
      Math.max(1, Math.min(page, this.totalPages())),
    );
  }
}
